/**
 * Atomic UI pieces reused across the Planner (bar, pill, field, hooks).
 */
import React, { useEffect } from "react";
import { STATUS_BUCKET_STYLE, STATUS_META } from "./constants";

/** Global Escape-to-close hook for modals. */
export function useEscapeKey(handler) {
  useEffect(() => {
    if (!handler) return undefined;
    const onKey = (e) => { if (e.key === "Escape") handler(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handler]);
}

export function CapacityBar({ pct, bucketStatus = "available" }) {
  const color = STATUS_BUCKET_STYLE[bucketStatus]?.ring || "#10b981";
  return (
    <div className="w-full h-1.5 rounded-full bg-white/5 overflow-hidden">
      <div className="h-full rounded-full transition-all"
           style={{ width: `${Math.min(100, pct)}%`, background: color }}/>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-widest font-bold text-slate-400">{label}</span>
      <div className="mt-1">{children}</div>
      {hint && <div className="mt-1 text-[10px] text-slate-500">{hint}</div>}
    </label>
  );
}

export function StatusPill({ status }) {
  const m = STATUS_META[status] || STATUS_META.new_request;
  const isKontroll = !!m.recurrence;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold border ${isKontroll ? "bg-cyan-500/15 text-cyan-200 border-cyan-400/40" : "bg-white/5 text-slate-300 border-white/10"}`}>
      {isKontroll
        ? <span className="text-[10px]" aria-hidden>🔁</span>
        : <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`}/>}
      {m.label}
    </span>
  );
}
